var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTableRow",
    { class: _vm.tableRowClass, attrs: { checkbox: _vm.checkboxValues } },
    [
      _vm._l(_vm.columns, function(column) {
        return [
          column.code === "participants"
            ? _c(
                "CompassTableBodyCell",
                { key: column.code, attrs: { maxWidth: "256px" } },
                [
                  _c(
                    "div",
                    { staticClass: "email-listing-table__cell-participants" },
                    [
                      _vm.isReceivedTable
                        ? _c("span", {
                            staticClass: "email-listing-table__state-dot"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "email-listing-table__cell-participants-label typographies-paragraph-medium-semibold"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.formattedParticipants) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "subject"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "email-listing-table__cell-subject",
                  attrs: { maxWidth: "506px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "email-listing-table__cell-subject-container"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "email-listing-table__cell-subject-content"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.email.subject) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.email.has_attachments
                        ? _c("CompassIcon", {
                            staticClass:
                              "email-listing-table__cell-subject-attachment",
                            attrs: { icon: "attachment", size: "small" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "related"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "email-listing-table__cell-related"
                },
                [
                  _vm.email.related.length > 0
                    ? _c("CompassButton", {
                        attrs: {
                          type: "tertiary",
                          leftIcon: "objects-linked",
                          label: "" + _vm.email.related.length
                        },
                        on: {
                          click: function($event) {
                            return _vm.openRelated(_vm.email)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "status"
            ? _c(
                "CompassTableBodyCell",
                { key: column.code, attrs: { maxWidth: "142px" } },
                [
                  _vm.isSentTable && _vm.email.is_open
                    ? _c(
                        "CompassTag",
                        { attrs: { color: _vm.EMAIL_STATUS.OPEN.tagColor } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.EMAIL_STATUS.OPEN.label) +
                              "\n            "
                          )
                        ]
                      )
                    : !_vm.isSentTable
                    ? _c(
                        "CompassTag",
                        { attrs: { color: _vm.getStatusColorTag() } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getStatusLabel()) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "date"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "email-listing-table__cell-date",
                  attrs: { maxWidth: "175px" }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formattedDate(_vm.email.date)) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "updated"
            ? _c(
                "CompassTableBodyCell",
                { key: column.code, attrs: { maxWidth: "175px" } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formattedDate(_vm.email.updated)) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "scheduled_at"
            ? _c(
                "CompassTableBodyCell",
                { key: column.code, attrs: { maxWidth: "225px" } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t.__("email.ScheduledEmailListing.scheduled_date")
                      ) +
                      " :\n            " +
                      _vm._s(_vm.formattedDate(_vm.email.scheduled_at)) +
                      "\n        "
                  )
                ]
              )
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c(
        "CompassTableBodyCell",
        {
          ref: "cell-actions",
          attrs: { fixed: "right", maxWidth: "64px", minWidth: "64px" }
        },
        [
          _c("EmailListingActions", {
            ref: "wrapper-icon-buttons",
            staticClass: "actions__container",
            attrs: { email: _vm.email },
            on: {
              "update:readingStatus": _vm.updateReadingStatus,
              "open:related": _vm.openRelated
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }